<script>
  import formatDate from '@utils/format-date'
  import VueContentLoading from 'vue-content-loading'
  import dialogMixin from "./mixins/dialog";
  import { couponDateRange } from "@utils/zerone-coupon";

  export default {
    filters: {
      formatDate,
    },
    components: {
      VueContentLoading
    },
    mixins: [dialogMixin],
    props: {
      couponInfo: {
        type: Object,
        default: () => {
          return {
            code: "coupon2",
            discountType: null,
            discountValue: 0,
            endDate: null,
            title: "上課券1"
          }
        },
      },
      isUnpaid: {
        type: Boolean,
        require: true
      },
      cartItem: {
        type: Object,
        default: () => {
          return {}
        }
      },
    },
    data() {
      return {
        couponList: [],
        tempCoupon: {},
      }
    },
    watch: {
      dialogMixinDialogVisible(value) {
        if(this.couponList.length === 0) {
          this.tryToFetchMemberCouponList();
        }

        if(value) {
          this.setTempCoupon();
        }
      },
    },
    methods: {
      formatDate,
      couponDateRange,
      onConfirm() {
        this.dialogMixinDialogVisible = false;

        this.$emit('change', this.tempCoupon);
      },
      onClickItem(item) {
        this.tempCoupon = item
      },
      tryToFetchMemberCouponList() {
        this.$store.dispatch('coupon/fetchCouponList', {
          eventAlias: this.cartItem.alias,
          limit: 999
        })
          .then((response) => {
            this.couponList = response.items;
          })
      },
      setTempCoupon() {
        this.tempCoupon = this.couponInfo;
      }
    },
  }
</script>
<template>
  <el-dialog
    :visible.sync="dialogMixinDialogVisible"
    :before-close="$DialogMixinOnClose"
    :custom-class="`${ $style.dialogCoupon } isStyleLogin`"
    width="876px"
    append-to-body
  >
    <div class="sectionTitle text-center mb-5 font-medium color-gray-7">選取上課卷</div>
    <template v-if="$isLoading('fetchCouponList') && couponList.length === 0">
      <VueContentLoading
        :width="396"
        :height="570"
        :speed="3"
      >
        <rect x="0" y="0" rx="0" ry="0" width="396" height="140"/>
        <rect x="0" y="170" rx="0" ry="0" width="396" height="140"/>
      </VueContentLoading>
    </template>
    <template v-else>
      <template v-if="couponList.length === 0 && !$isLoading('fetchCouponList')">
        <BaseNull
          content="沒有可以使用的優惠券"
        />
      </template>
      <template v-else>
        <div class="couponList">
          <div
            v-for="(item, index) in couponList"
            :key="index"
            :class="[{ isActive: item.code === tempCoupon.code }]"
            class="couponItem"
            @click="onClickItem(item)"
          >
            <div class="d-flex justify-content-md-between flex-md-row flex-column">
              <div class="order-md-first order-last">
                <!-- <div class="text color-gray-5 mb-2">{{ item.code }}</div> -->
                <BaseSectionTitle2 
                  class="title color-gray-7 font-medium" 
                  :title="item.title" 
                  :coupon="item.code"
                />
                <div class="text-base color-gray-5 mb-2">* 報名零壹上課券限定課程，請輸入此組序號</div>
              </div>
              <div class="mt-1">
                <div class="bg-primary text-white p-md-2 p-1 assign">
                  上課卷
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <div>
                <div class="text mt-4 color-gray-5 couponItem__date">
                  {{ couponDateRange({ ...item }) }}
                </div>
              </div>
              <div class="align-self-end couponItem__img pl-sm-3 d-sm-block d-none">
                <img src="@assets/images/logo/logo.svg" alt="" width="152">
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>
    <div class="mt-4 couponBtnBox">
      <BaseButton
        :disabled="!tempCoupon.code"
        class="isStylePrimary isFull isRadius"
        @click="onConfirm"
      >
        確認使用
      </BaseButton>
      <BaseButton
        class="isStyleGray isOutline2 mt-4 isFull isRadius"
        @click="$DialogMixinOnClose"
      >
        取消
      </BaseButton>
    </div>
    <BasePre>couponInfo: {{ couponInfo }}</BasePre>
    <BasePre>couponList: {{ couponList }}</BasePre>
    <!--<pre>{{list}}</pre>-->
  </el-dialog>
</template>
<style lang="scss" module>
  .dialogCoupon {
    :global {
      .sectionTitle {
        font-size: 24px;
      }

      .couponList {
        height: 570px;
        padding: 0 19px;
        overflow-y: auto;
        @include max-md {
          padding: 0;
        }
        .couponItem {
          position: relative;
          padding: 2.5rem;
          cursor: pointer;
          border: 2px solid $color-primary;

          &::before {
            position: absolute;
            right: 29px;
            bottom: 0;
            width: 195px;
            padding-bottom: 213px;
            content: '';
            background-image: url('~@assets/images/course/couponbg.svg');
            background-repeat: no-repeat;
            background-position: 96%;
            background-size: cover;
          }

          @include max-md {
            padding: 2rem;
          }

          @include max-sm {
            padding: $container-gap;
            &::before {
              width: 183px;
              padding-bottom: 200px;
              right: 0;
            }
          }

          &:not(:last-child) {
            margin-bottom: 2rem;
          }

          &:hover:not(.isActive) {
            // border-color: $color-primary-hover;
            box-shadow: 0 0 8px rgba(33, 69, 88, 0.16);

            .title {
              color: $color-primary;
            }
          }

          &.isActive {
            border-color: $color-primary-hover;

            .title {
              color: $color-primary;
            }
          }

          .title {
            font-size: 24px;
            letter-spacing: 0.2rem;
            transition: .3s;
            margin-bottom: 1.9rem;
            @include max-md {
              font-size: 22px;
            }
          }

          .text {
            font-size: 14px;
          }

          .price {
            width: 100px;
            height: 45px;
            font-size: 20px;
            line-height: 45px;
            color: #FFF;
            // padding: .5rem 1rem;s
            text-align: center;
            letter-spacing: 0.2em;
            background: $color-primary;
            border-radius: 5px;

            @include max-md {
              font-size: 18px;
            }
          }

          .assign {
            width: 80px;
            text-align: center;
            @include max-md {
              width: 60px;
            }
          }
          &__img {
            @include max-md {
              width: 95px;
            }
          }
        }
      }

      .couponBtnBox {
        padding: 0 19px;
        @include max-md {
          padding: 0;
        }
      }
    }
  }
</style>
